import React from 'react';
import { Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import useRouter from '../../utils/useRouter';
import SubscribeIcon from '../../assets/subscription/subscribe.svg';
import { borderRadius, palette } from '../../assets/styles/themes/tokens';
import { selectUser } from '../../reducers/user.selectors';
import { AdditionalInfoType, getUpgradeBannerProps, PremiumBenefits } from './utils/upgradeBannerUtils';
import ReaderBanner from '../CustomBanner';
import { useTranslation } from 'react-i18next';
import Benefits from '../PricingPackage/Benefits';
import { getDownloadBannerProps } from './utils/downloadBannerUtils';
interface ReaderBannerContainerProps {
  index: number;
  downloadMindItem: () => void;
  isReadOnly?: boolean;
}

const ReaderBannerContainer: React.FC<ReaderBannerContainerProps> = ({ isReadOnly, index, downloadMindItem }) => {
  const { t } = useTranslation();
  const user = useSelector(selectUser);
  const { router } = useRouter();
  let bannerProps;

  if (!user) return null;

  const getAdditionalInfo = (type: AdditionalInfoType) => {
    let additionalInfo = null;
    if (type === 'premium') {
      additionalInfo = <Benefits benefit={PremiumBenefits} />;
    } else if (type === 'course') {
      additionalInfo = (
        <Typography variant='body1' sx={{ color: palette.text.secondary }}>
          {t(
            'You need meinUnterricht 360 for this document. Currently, you cannot adjust your subscription yourself—' +
            'but our support team will be happy to help.'
          )}
        </Typography>
      );
    }
    return additionalInfo;
  };

  if (!isReadOnly && index === 1) {
    bannerProps = getDownloadBannerProps(user, downloadMindItem, router, t);
  } else {
    const upgradeBannerProps = getUpgradeBannerProps(user, router, SubscribeIcon, t);
    
    bannerProps = {
      ...upgradeBannerProps,
      additionalInfo: getAdditionalInfo(upgradeBannerProps.additionalInfoType),
    };
  }

  return (
    <Box sx={{
      position: 'absolute',
      height: '100%',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}>
      <ReaderBanner
        open={true}
        {...bannerProps}
        dialogProps={{ 
          disablePortal: true,
          disableEscapeKeyDown: true,
          disableAutoFocus: true,
          disableEnforceFocus: true,
          sx: { position: 'absolute' },
          slotProps: {
            backdrop: {
              sx: { 
                borderRadius: borderRadius.sm,
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
              }
            }
          }
        }}
      />
    </Box>
  );
};

export default ReaderBannerContainer;
